import {
  Building2,
  ChevronLeft,
  ChevronRight,
  FileText,
  Users,
} from 'lucide-react'
import { useState } from 'react'

const userTypes = [
  {
    title: 'Freelancers & Contractors',
    description:
      'Easily file your Self Assessment without needing an accountant — guided forms and real-time tax calculations included.',
    icon: FileText,
  },
  {
    title: 'Small Business Owners',
    description:
      'Handle Corporation Tax (CT600) and submit your iXBRL accounts in minutes, saving time and avoiding penalties.',
    icon: Building2,
  },
  {
    title: 'Limited Companies',
    description:
      'Generate comprehensive company accounts, manage compliance requirements, and streamline your tax obligations.',
    icon: Users,
  },
  {
    title: 'Freelancers & Contractors',
    description:
      'Easily file your Self Assessment without needing an accountant — guided forms and real-time tax calculations included.',
    icon: FileText,
  },
  {
    title: 'Small Business Owners',
    description:
      'Handle Corporation Tax (CT600) and submit your iXBRL accounts in minutes, saving time and avoiding penalties.',
    icon: Building2,
  },
  {
    title: 'Limited Companies',
    description:
      'Generate comprehensive company accounts, manage compliance requirements, and streamline your tax obligations.',
    icon: Users,
  },
]

const CARDS_PER_PAGE = 2

export default function BritFilerPage() {
  const [currentPage, setCurrentPage] = useState(0)
  const totalPages = Math.ceil(userTypes.length / CARDS_PER_PAGE)

  const nextSlide = () => {
    setCurrentPage(prev => (prev + 1) % totalPages)
  }

  const prevSlide = () => {
    setCurrentPage(prev => (prev - 1 + totalPages) % totalPages)
  }

  return (
    <div className='bg-transparent py-8 sm:py-12 lg:py-16 px-4 sm:px-6 lg:px-20'>
      <div className='w-full mx-auto'>
        <div className='bg-[#EEF0F2] rounded-2xl p-4 sm:p-6 lg:p-8 shadow-sm'>
          <div className='grid grid-cols-1 lg:grid-cols-2 gap-6 sm:gap-8 items-center'>
            {/* Main Highlight Card */}
            <div className='bg-[#1C1E24] rounded-2xl p-6 sm:p-8 lg:p-12 text-white'>
              <h1 className='text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-4 sm:mb-6 text-balance'>
                Who can use BritFiler?
              </h1>
              <p className='text-base sm:text-lg lg:text-xl text-gray-300 leading-relaxed text-pretty'>
                BritFiler is for freelancers, businesses, and accountants —
                making Self Assessment, Corporation Tax, iXBRL, and Confirmation
                Statements simple, accurate, and stress-free.
              </p>
            </div>

            {/* Carousel Section - iPad & Desktop */}
            <div className='relative hidden md:block'>
              <div className='flex items-center gap-4'>
                {/* Left Arrow */}
                <button
                  onClick={prevSlide}
                  className='shrink-0 w-12 h-12 rounded-full bg-white flex items-center justify-center'
                >
                  <ChevronLeft className='w-5 h-5' color='#000000' />
                </button>

                {/* Carousel Cards Container */}
                <div className='flex-1 overflow-hidden'>
                  <div
                    className='flex transition-transform duration-300 ease-in-out'
                    style={{ transform: `translateX(-${currentPage * 100}%)` }}
                  >
                    {Array.from({ length: totalPages }).map((_, pageIdx) => (
                      <div
                        key={pageIdx}
                        className='w-full shrink-0 flex gap-4'
                      >
                        {userTypes
                          .slice(
                            pageIdx * CARDS_PER_PAGE,
                            (pageIdx + 1) * CARDS_PER_PAGE,
                          )
                          .map((userType, idx) => {
                            const IconComponent = userType.icon
                            return (
                              <div
                                key={idx}
                                className='flex-1 min-w-0 h-[310px] p-4 flex flex-col space-y-4 justify-between items-start bg-transparent border rounded-2xl'
                                style={{
                                  borderColor: 'rgba(134, 133, 137, 0.24)',
                                }}
                              >
                                <h3 className='text-xl font-bold text-gray-900 text-balance text-start'>
                                  {userType.title}
                                </h3>
                                <p className='text-gray-600 leading-relaxed text-pretty text-start'>
                                  {userType.description}
                                </p>
                                <div className='pt-2'>
                                  <div className='w-10 h-10 bg-red-50 rounded-lg flex items-center justify-center'>
                                    <IconComponent className='w-5 h-5 text-red-600' />
                                  </div>
                                </div>
                              </div>
                            )
                          })}
                      </div>
                    ))}
                  </div>
                </div>

                {/* Right Arrow */}
                <button
                  onClick={nextSlide}
                  className='shrink-0 w-12 h-12 rounded-full bg-[#F04438] flex items-center justify-center'
                >
                  <ChevronRight className='w-5 h-5' color='#FFFFFF' />
                </button>
              </div>
            </div>
          </div>

          {/* Mobile: Show all cards stacked */}
          <div className='mt-6 sm:mt-8 space-y-4 md:hidden'>
            {userTypes.slice(0, 3).map((userType, index) => {
              const IconComponent = userType.icon
              return (
                <div
                  key={index}
                  className='p-4 sm:p-6 bg-white border border-gray-200 rounded-2xl shadow-sm'
                >
                  <div className='space-y-3 sm:space-y-4'>
                    <h3 className='text-lg sm:text-xl font-bold text-gray-900 text-balance'>
                      {userType.title}
                    </h3>
                    <p className='text-sm sm:text-base text-gray-600 leading-relaxed text-pretty'>
                      {userType.description}
                    </p>
                    <div className='pt-2'>
                      <div className='w-10 h-10 bg-red-50 rounded-lg flex items-center justify-center'>
                        <IconComponent className='w-5 h-5 text-red-600' />
                      </div>
                    </div>
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </div>
  )
}
